var addressFinderInit = function () {
    $('[data-id="address-finder-postcode-search-submit"]').each(function () {
        new AddressFinder($(this)).init();
    });
};

(function ($) {
    var AddressFinder = window.AddressFinder = function (submitButton) {
        var _self = this,
        guid = submitButton.attr("data-container-guid"),
        addressResults = $("[id='searchresults_" + guid + "']"),
        addressOptions = $("[data-guid='addressoptions_" + guid + "']"),
        addressOptionsButton = $("[id='btn_addressoptions']"),
        addressOptionsTitle = $("[data-guid='addressoptionstitle_" + guid + "']"),
        selectedAddress = $("[id='selectedaddress_" + guid + "']"),
        editSelectedAddress = $("[id='selectedaddress_" + guid + "'] a[data-id='editAddress']"),
        deleteSelectedAddress = $("[id='selectedaddress_" + guid + "'] a[data-id='removeAddress']"),
        postcodeSearch = $("[id='search_" + guid + "']"),
        postcodeInput = submitButton.prev('input'),
        showManualForm = $("[id='showmanualform_" + guid + "']"),
        manualFormLocator = $("[id='manualentry_" + guid + "']"),
        manualPostcodeInput = manualFormLocator.find('[data-id=address-postcode]'),
        noResultsLocator = $("[id='searchnoresults_" + guid + "']"),
        hr = $("[id='hr_" + guid + "']"),
        removeButton = submitButton.siblings("[data-id=removeAddressButton]"),
        uprnInput = manualFormLocator.find('[data-id=address-uprn]'),
        vb = removeButton;
        var addEvents = function () {
            //attach event handler with remove button
            if (islington.checkValidity(removeButton)) {
                removeAddressInit(removeButton);
                removeAddressInit(deleteSelectedAddress);
            }

            submitButton.
                off('click').
                on('click', function (evt) {

                    evt.preventDefault();

                    var isValid = $(this).parents("form").data('validator').element("[data-id='postcodefield_" + guid + "']");

                    //manualFormLocator.addClass("x");
                    if (isValid) {
                        addressOptions.empty();
                        var postcode = submitButton.parent().find("input[type='text']").val();

                        $.post('/gis/findaddresses?postcode=' + postcode)
                            .done(function (data) {
                                showAddressResults(data);
                                // valid postcode focus on address dropdown

                        })
                        .fail(function (data) {
                            showAddressResults(data);
                        });
                    }
                });


            addressOptionsButton.off('click').on("click", function () {
                var selectedAddress = addressOptions.val();

                if (selectedAddress) {
                    var addressData = JSON.parse(selectedAddress);
                    var addressParent = addressOptions.parents("li");
                    uprnInput.val(addressData.Uprn);
                    updateFurnitureWithSelectedAddress(addressData, addressParent);
                    /*                    editSelectedAddress.focus();*/
                    islington.giveScreenreaderAlert('Address selected', 'sr-addressfinder-announcement');
                    setTimeout(() => {
                        islington.giveScreenreaderAlert('', 'sr-addressfinder-announcement');
                    }, 1000);

                    $('input').bind('keydown', function () {
                        if (event.keyCode == 13) {
                            event.preventDefault();
                            $('#submit_button').click();
                        }
                    });


                }
            });

            editSelectedAddress.off('click').on('click', function (evt) {
                evt.preventDefault();
                var addressData = JSON.parse(addressOptions.val()),
                    isUPRNSet = islington.isEmpty(uprnInput.val()) ? false : true;
                if (addressData) {
                    postcodeInput.val(addressData.Postcode);
                }
                showField(postcodeSearch);
                postcodeSearch.find('input').focus();
                if (!isUPRNSet)     
                    showManualEntryForm();
                hideField(addressResults);
                hideField(selectedAddress);
            });      
        };

        var updateFurnitureWithSelectedAddress = function (addressData) {
            hideField(addressResults);
            hideField(postcodeSearch);
            hideManualEntryForm();
            showField(selectedAddress);

            selectedAddress.find(".m-confirmation-single")
                .empty()
                .append(
                    "<p>"
                    + appendAddressFieldIfSet(addressData.Line1)
                    + appendAddressFieldIfSet(addressData.Line2)
                    + appendAddressFieldIfSet(addressData.Line3)
                    + appendAddressFieldIfSet(addressData.City)
                    + appendAddressFieldIfSet(addressData.Postcode.toUpperCase()) 
                    + appendAddressFieldIfSet(addressData.RateableValue)
                    + "</p>");  
           
        };

        var showAddressResults = function (addressData) {
            showField(addressResults);
            if (addressData) {
                addressOptions.append(addressData);

                showField(addressOptions);
                showField(addressOptionsTitle);
                //hideField(noResultsLocator);
                $('h3#no-address').addClass("x");
                $('.m-form--bulkywaste-address .m-alert.m-alert-info.m-alert-instruction').addClass("x");

                // focus on select dropdown
                addressOptions.focus();

            } else {

                hideField(addressOptions);
                hideField(addressOptionsButton);
                hideField(addressOptionsTitle);
                showField(noResultsLocator);
                uprnInput.val("");
                $('h3#no-address').removeClass("x");
                $('#no-address-status').text('');         
                setTimeout(() => {
                    $('#no-address-status').text('Sorry, no address could be found');
                }, 50);                
                $('.m-form--bulkywaste-address .m-alert.m-alert-info.m-alert-instruction').removeClass("x");
            }

            showManualForm.off().on("click", function (evt) {
                evt.preventDefault();
                toggleManualEntryForm($(this));
                addressResults.hide();
            });
        };

        var showField = function (field) {
            field.removeClass("x");
            field.show();
        };

        var hideField = function (field) {
            field.addClass("x");
            field.hide();
        };

        var appendAddressFieldIfSet = function (field) {
            var value = '';

            if (field) {
                value = field + "<br />";
            }

            return value;
        };

        var toggleManualEntryForm = function (item) {
            var field = manualFormLocator,
            addressFinder = submitButton.closest(".m-addressFinder");
            addressFinder.addClass("is-manualAddress");
            if (field.hasClass("x")) {
                showManualEntryForm(field);

                item.parents("form").data('validator').resetForm();

                mando.resetFormValidation(item.parents("form"));

                hideField(addressOptions);
                hideField(addressOptionsTitle);
            }
            //else {
            //    hideManualEntryForm(field);
            //}
        };

        var showManualEntryForm = function () {
            var field = manualFormLocator;

            showField(field);
            
            mandatoryFields = field.find("input[data-val-required]");
            
            mandatoryFields.each(function () {
                var inpt = $(this); 
                inpt.rules("add", {
                    required: true,
                    messages: {
                        required: inpt.data('val-required')
                    }                        
                });
            });           

            manualPostcodeInput.val(postcodeInput.val());

            field.attr({
                'aria-expanded': 'true',
                'aria-selected': 'true',
                'aria-hidden': 'false'
            });
        };

        var hideManualEntryForm = function () {
            var field = manualFormLocator;

            hideField(field);
            field.attr({
                'aria-expanded': 'false',
                'aria-selected': 'false',
                'aria-hidden': 'true'
            });
        };

        _self.init = function () {
            if (submitButton[0]) {
                addEvents();

                if (!addressOptions.empty() && addressOption.val() && addressOptions.val().length > 0) {
                    hideField(postcodeSearch);
                    hideField(manualFormLocator);
                }
            }
        };
    };
})(jQuery);

/*
 * To set manual address from fields as selector 
 * option on form submission
 */
$("form").on("submit", function () {
    $("[data-id=address-finder-manual-form]:visible").each(function () {
        _self = $(this),
        select = _self.siblings("[data-id=address-finder-results]")
            .find("select"),
        optionValue = {
            "Line1": null, "Line2": null, "Line3": null,
            "City": null, "Postcode": null, "RateableValue": 0, "Uprn": null, "IsSet": true
        },
        optionText = "",
        inputs = _self.find("input"),
        index = 0;

        for (var i in optionValue) {
            if (i == "Uprn")
                break;
            var fieldVal = inputs[index].value;
            if (i == "RateableValue" && fieldVal == "")
                fieldVal = 0;
            optionValue[i] = fieldVal;
            optionText += fieldVal + ',';
            ++index;
        }

        var option = new Option(optionText, JSON.stringify(optionValue));
        select.empty().
            append(option);
    });
});


/*
/*
 *Quick fix for failing client side validation for dynamically added addressfinders on form submission* 
 */
$("input[type=submit],button[type=submit]").on("click", function () {
    var inpt = $(this),
        isPreviousStep = (inpt.attr("formnovalidate") == undefined) ? false : true ||
        inpt.val().toLowerCase() == "previous";
    //For only Next step
    if (!isPreviousStep) {

        var form = inpt.closest("form"),
            isThereAnyAddressFinder = (form.has(".m-addressFinder").length == 0)?false:true;

        if (isThereAnyAddressFinder) {
            var validatorObj = form.validate();
            if (!validatorObj.form())
                return false;
        }
    }
})